import { CategoryNoLinkCell, DefaultCell, IndexCell, RankCell, TrafficShare } from "app/components/React/Table/cells";
import type { TranslationReplacement } from "app/filters/i18nFilter";
import { i18nFilter } from "app/filters/i18nFilter";
import { AppCell } from "app/pages/app-intelligence/common-components/table-cells/AppCell";

export const getAffinityColumns = (i18nReplacements?: Readonly<Partial<Record<string, TranslationReplacement>>>) => [
    {
        field: "",
        displayName: "#",
        cellComponent: IndexCell,
        fixed: true,
        width: 60,
        sortable: false,
        disableHeaderCellHover: true,
        headerCellClass: "index-cell-header",
    },
    {
        fixed: true,
        field: "Title",
        displayName: i18nFilter()("mobileApps.affinity.table.columns.apptitle"),
        cellComponent: ({ row, showStoreIcon, onIntenalTrack }) => {
            const {
                AppStore: appStore,
                Author: author,
                Category: category,
                Icon: icon,
                Price: price,
                Title: title,
            } = row.Tooltip;
            const transformedRow = {
                app: row.AppID,
                appId: row.AppID,
                title: row.Title,
                tooltip: {
                    appStore,
                    author,
                    category,
                    icon,
                    price,
                    title,
                },
                url: row.url,
            };
            return (
                <AppCell
                    row={transformedRow}
                    onIntenalTrack={onIntenalTrack}
                    showStoreIcon={showStoreIcon}
                />
            );
        },
        showTotalCount: true,
        width: 300,
        sortable: true,
    },
    {
        field: "Publisher",
        displayName: i18nFilter()("mobileApps.affinity.table.columns.publisher"),
        cellComponent: DefaultCell,
        width: 150,
        sortable: true,
    },
    {
        field: "MainCategoryID",
        displayName: i18nFilter()("mobileApps.affinity.table.columns.category"),
        cellComponent: CategoryNoLinkCell,
        width: 150,
        sortable: true,
    },
    {
        field: "CategoryRank",
        displayName: i18nFilter()("mobileApps.affinity.table.columns.categoryrank"),
        cellComponent: RankCell,
        width: 150,
        tooltip: i18nFilter()("mobileApps.affinity.table.columns.categoryrank.tooltip"),
        sortable: true,
    },
    {
        field: "CountryRank",
        displayName: i18nFilter()("mobileApps.affinity.table.columns.countryrank"),
        cellComponent: RankCell,
        width: 150,
        tooltip: i18nFilter()("mobileApps.affinity.table.columns.countryrank.tooltip"),
        sortable: true,
    },
    {
        field: "Affinity",
        displayName: i18nFilter()("mobileApps.affinity.table.columns.affinity"),
        cellComponent: TrafficShare,
        width: 350,
        tooltip:
            i18nReplacements && i18nFilter()("mobileApps.affinity.table.columns.affinity.tooltip", i18nReplacements),
        sortable: true,
    },
];
